<template>
  <v-card>
      <plan-gate service="partners" />
      <loading
        :active.sync="isLoading"
        :is-full-page="true"
        color="#1976d2"
        :background-color="$vuetify.theme.dark ? '#000' : ''"
      ></loading>
      <v-card-title>
        <h2>{{ $t('partners.new') }}</h2>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model.trim="investor.name"
              :label="$t('users.name')"
              outlined
              data-testid="new-investor-name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model.number="company_percent"
              :label="$t('investor_types.company_percent')"
              outlined
              :hint="$t('investor_types.company_percent_hint')"
              data-testid="new-investor-company-percent"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model.number="investor.percent"
              readonly
              :disabled="true"
              :label="$t('investor_types.investors_percent')"
              outlined
              :hint="$t('investor_types.investors_percent_hint')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-select
              v-model="investor.mode"
              :items="investor_types"
              item-text="text"
              item-value="value"
              :label="$t('investor_types.select_investor_type')"
              :hint="selectedInvestorTypeHint(investor.mode)"
              outlined
              data-testid="new-investor-mode"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="investor.categories"
              :items="investor_categories"
              item-value="id"
              :label="$t('partners.categories')"
              outlined
              multiple
              data-testid="new-investor-categories"
            >
              <template v-slot:selection="{ item }">
                <v-chip
                  :color="getOperationTypeColor(item.operation_type)"
                  small
                  class="mr-1"
                >
                  <v-icon v-if="item.operation_type === 1" small left>mdi-arrow-up</v-icon>
                  <v-icon v-else-if="item.operation_type === 0" small left>mdi-arrow-down</v-icon>
                  {{ translateCategory(item.value) }}
                </v-chip>
              </template>

              <template v-slot:item="{ item }">
                <v-list-item-icon class="mr-2">
                  <v-icon v-if="item.value != 'Залог'" :color="getOperationTypeColor(item.operation_type)">
                    {{ getOperationTypeIcon(item.operation_type) }}
                  </v-icon>
                  <v-icon v-if="item.value == 'Залог'" color="warning">mdi-arrow-up-down</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ translateCategory(item.value) }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12">
            <v-switch v-model="investor.can_view_booking_card" :label="$t('custom.can_view_booking_card')" class="mt-0"></v-switch>
          </v-col>
          <v-col cols="12">
            <v-switch v-model="investor.can_view_maintenances" :label="$t('custom.can_view_maintenances')" class="mt-0"></v-switch>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="investor.description"
              auto-grow
              clearable
              rows="1"
              :label="$t('custom.description_2')"
              outlined
            ></v-textarea>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn color="success" @click="savePartner()" :loading="isLoadingSavePartner" data-testid="new-investor-save-btn">{{ $t('custom.save') }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
</template>
<script>
import { translateCountCategory } from "@/utils/countCategory";
import moment from "moment";
export default {
  data() {
    return {
      investor: {
        name: null,
        percent: 0,
        mode: "Доходы - (Комиссия партнера - Расходы)",
        description: null,
        categories: [],
        can_view_booking_card: false,
        can_view_maintenances: true
      },
      company_percent: 0,
      investor_types: [
        {text: this.$t('investor_types.income_expences_with_commission'), value: "Доходы - (Комиссия партнера - Расходы)"},
        {text: this.$t('investor_types.income_expences'), value: "Доходы - Расходы"},
        {text: this.$t('investor_types.income'), value: "Доходы"},
      ],
      investor_categories: [],
      isMobile: false,
      isLoading: false,
      isLoadingSavePartner: false,
      isLoadingSubscribeToPaidTariff: false,
      error: ""
    }
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      // Создание партнёра — manager+, как экран списка (Investors.vue): сюда
      // ведёт только его кнопка, но маршрут открыт прямым URL, а рядовому
      // user сервер отвечает 403 manager_required (FT-184 CP-03, money-2).
      if (!this.isManagerPlus) {
        this.goBack();
        this.$notify(this.$t('errors.not_permitted_title'), this.$t('errors.only_admins_2'), "error", 5000);
        return;
      }
      this.isLoading = true;
      this.axios
        .get(
          "/api/v1/counts_categories",
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        )
        .then(response => {
          this.investor_categories = response.data;
        })
        .catch(error => {
          this.setError(error, this.$t('errors.partners_add'));
        })
        .finally(() => (this.isLoading = false));
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  watch: {
    company_percent() {
      this.investor.percent = 100 - parseInt(this.company_percent);
    }
  },
  computed: {
    userMustChangeTariffPlan() {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.id) {
          if(this.$store.getters.getMainCompany.plan.name == "Старт" || this.$store.getters.getMainCompany.plan.name == "Start") {
            if(this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment())) {
              return false;
            } else if (!this.$store.getters.getMainCompany.plan.trial_end && this.$store.getters.getMainCompany.created_at) {
              return moment(this.$store.getters.getMainCompany.created_at).isBefore(moment().subtract(7, "day")) ? true : false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          return false
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    savePartner() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      if (this.isManagerPlus) {
        let self = this;
        if (this.investor.name && this.investor.mode && this.investor.categories && this.investor.categories.length > 0) {
          this.isLoadingSavePartner = true;
          this.axios
            .post(
              "/api/v1/investors",
              {
                investors: {
                  name: self.investor.name,
                  percent: self.investor.percent,
                  mode: self.investor.mode,
                  counts_category_ids: self.investor.categories,
                  description: self.investor.description,
                  can_view_booking_card: self.investor.can_view_booking_card,
                  can_view_maintenances: self.investor.can_view_maintenances
                }
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken
                }
              }
            )
            .then(() => {
              this.$router.replace("/investors");
              this.$notify(this.$t('partners.added'), this.$t('partners.added_text'), "success", 3000);
            })
            .catch(error => {
              this.setError(error, this.$t('errors.partners_add'));
            })
            .finally(() => (this.isLoadingSavePartner = false));
        } else {
          this.$notify(this.$t('errors.all_fields_title'), this.$t('errors.all_fields_text'), "warning", 4000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    selectedInvestorTypeHint(mode) {
      switch (mode) {
        case "Доходы":
          return this.$t('investor_types.income_description');
        case "Доходы - Расходы":
          return this.$t('investor_types.income_expences_description');
        case "Доходы - (Комиссия партнера - Расходы)":
          return this.$t('investor_types.income_expences_with_commission_description');
        default:
          return '';
      }
    },
    translateCategory(category) {
      return translateCountCategory((key) => this.$t(key), category);
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        if (this.PageData && this.PageData.backCrumb && this.PageData.backCrumb.url) {
          var fpath = this.PageData.backCrumb.url;
          this.$router.push({
            path: fpath
          });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    getOperationTypeColor(type) {
      if (type) {
        return 'success';
      } else {
        return 'error';
      }
    },
    getOperationTypeIcon(type) {
      if (type) {
        return 'mdi-arrow-up';
      } else {
        return 'mdi-arrow-down';
      }
    },
  },
  components: {}
};
</script>
